import React, { useState } from 'react';
import classNames from 'classnames';

import { VideoContainerProps } from './VideoContainerProps';

import * as styles from './VideoContainer.module.scss';
import { FallbackImage } from './components/FallbackImage/FallbackImage';
import { HOME_VIDEO_LINK } from '@store/HomeData';
import useTimeout from '@utils/hooks/useTimeout';
import useSmallDevice from '@utils/hooks/useSmallDevice';

export const VideoContainer: React.FC<VideoContainerProps> = ({
	children,
	options,
	maxVideoHeight = '100%',
	videoStyles = {},
	fallbackImageStyles,
}) => {
	const [shouldFallback, setShouldFallback] = useState(true);
	const isSmallDevice = useSmallDevice();
	const loadVideo = useTimeout(1000);

	return (
		<div className="relative d-flex">
			<div
				className="overflow-hidden flex-1"
				style={{ maxHeight: maxVideoHeight }}
			>
				{shouldFallback && (
					<FallbackImage fallbackImageStyles={fallbackImageStyles} />
				)}
				{loadVideo && !isSmallDevice && (
					<video
						style={videoStyles}
						className={classNames(
							styles.fluid,
							shouldFallback && styles.hidden
						)}
						{...options}
						onCanPlay={() => {
							setShouldFallback(false);
						}}
					>
						<source type="video/webm" src={HOME_VIDEO_LINK} />
					</video>
				)}
			</div>
			<div className={styles.childrenContainer}>{children}</div>
		</div>
	);
};
